
export default [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Informações do Documento',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
        type: 'select-custom',
        field: 'id_emp',
        label: 'Empresa',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        title: {
            link: 'id_emp',
            icon: 'fa fa-pencil-square-o'
        },
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
        type: 'select-custom',
        field: 'id_fdt',
        label: 'Frente de Trabalho',
        option: {
            key: 'id',
            label: 'fdt',
            value: 'id'
        },
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
        type: 'select-tipo',
        field: 'id_tipo_revisao',
        tipo: 1,
        label: 'Tipo da Revisão',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'date',
        field: 'data',
        label: 'Data Documento',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5',
        type: 'select-custom',
        field: 'id_mod',
        label: 'Modelo do Documento',
        option: {
            key: 'id',
            label: 'modelo',
            value: 'id'
        },
        info: 'Para criar novos modelos acesso o menú LTCAT Modelos',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-custom',
        field: 'id_res',
        label: 'Responsável pelo LTCAT',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'id_tipo_ltcat',
        tipo: 203,
        label: 'Tipo do cadastro do LTCAT',
        info: '',
        disabled:true,
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'id_rev',
        label: 'PPRA Copiado',
        info: '',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'obs',
        label: 'Observações',
        maxlength: 500,
        info: '',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/_form/ltcat-editar.js